import { Box, Typography } from '@mui/material';

import { SymbolAlias } from '@/features/Dashboard/components/SymbolAlias/';
import { chartPaletteSelection } from '@/features/Dashboard/form/AppForm/components/ColorPaletteSelector/const';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';

const ColorSelectionList = () => {
  const { form } = useAppForm();

  return (
    <form.Subscribe
      selector={s => ({
        symbols: s.values?.symbols,
        colorPalette: s.values && 'colorPalette' in s.values ? s.values.colorPalette : undefined,
        type: s.values?.type
      })}
    >
      {({ symbols, colorPalette, type }) => {
        const pallette = chartPaletteSelection.find(item => item.id === colorPalette)!;

        const symbolsToPreview = symbols?.active.slice(0, pallette?.palette?.length ?? 0) ?? [];

        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', mb: 1 }}>
            <Box
              sx={{ display: 'flex', flexDirection: 'row', fontSize: 14, fontWeight: 500, mb: 1 }}
            >
              <Box sx={{ ml: 1.5, width: 100 }}>Color</Box>
              <Box sx={{ width: 100 }}>Alias</Box>
              <Box>Short Title</Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              {symbolsToPreview.map((symbol, index) => (
                <Box
                  key={JSON.stringify(symbol.symbol)}
                  sx={{
                    border: 1,
                    p: 1.5,
                    display: 'flex',
                    flexDirection: 'row',
                    fontSize: 14,
                    mb: 2,
                    '&:last-child': { mb: 0 }
                  }}
                >
                  <Box sx={{ width: 100, display: 'flex', flexDirection: 'row' }}>
                    <Box
                      sx={{ backgroundColor: pallette.palette[index].hex, width: 16, height: 16 }}
                    />
                    <Typography sx={{ pl: 1, fontSize: 14 }}>
                      {pallette.palette[index].name}
                    </Typography>
                  </Box>
                  <Box sx={{ width: 100 }}>
                    <SymbolAlias
                      symbol={symbol}
                      type={type}
                    />
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '300px'
                    }}
                  >
                    {symbol.shortTitle}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        );
      }}
    </form.Subscribe>
  );
};

export default ColorSelectionList;
